// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"3db8a674","27":"92747474","206":"757b8f76","357":"8ae91a8b","379":"c7903eba"}[chunkId] + ".js";
};